<template>
  <div>

    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="상품 기획전 조회"
      desc="등록된 기획전의 현황을 조회할 수 있습니다."
    ></admin-filter>

    <div class="btn-group-justify-end">
      <button @click="$router.push('exhibition/create')"
              class="button is-primary" style="width: auto">상품 기획전 등록</button>
    </div>

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 :table_width="1650"
                 @selPageLength="selPageLength">

      <div slot="product_list" slot-scope="props" style="text-align:left">
        <template v-for="(product, idx) in props.item.product_list">
          <div class="flex-align" style="margin-bottom:4px" :key="'product-'+idx" v-if="idx<3">
            <div :style="thumbImgField(product.first_img, 20, 20)"
                 style="margin-right:8px"
                 v-if="product.first_img"></div>
            <span style="max-width:130px">{{ product.name }}</span>
            <span v-if="idx < 2 && idx < props.item.product_list.length-1">,</span>
          </div>
        </template>
        <div v-if="props.item.product_list.length>3">외 {{ props.item.product_list.length - 3 }}개</div>
      </div>

      <div slot="display_type" slot-scope="props">
        <div v-if="props.item.display_type===0">노출</div>
        <div v-else-if="props.item.display_type===1">기간별 노출</div>
        <div v-else-if="props.item.display_type===2">노출안함</div>
      </div>

      <div slot="start_date" slot-scope="props">
        <div v-if="props.item.display_type===1">{{props.item.start_date}}</div>
      </div>

      <div slot="end_date" slot-scope="props">
        <div v-if="props.item.display_type===1">{{props.item.end_date}}</div>
      </div>

      <div slot="modify_delete" slot-scope="props">
        <button class="button half"
                @click.stop.prevent="clickItem(props.item,'update')" style="margin-right:4px">수정</button>
        <button class="button half is-danger"
                @click.stop.prevent="clickItem(props.item,'delete')" v-if="showItem(props.item.index)">삭제</button>
      </div>

    </admin-table>

    <!--<sweet-modal overlay-theme="dark" ref="deleteModal">
      <lp-modal>
        <span slot="title">기획전 삭제</span>
        <span slot="desc">기획전 항목을 삭제하시겠습니까?</span>
        <span slot="ok" @click="deleteItem">확인</span>
        <span slot="cancel" @click="$refs.deleteModal.close()">취소</span>
      </lp-modal>
    </sweet-modal>-->

  </div>
</template>

<script>
  import ListMixin from '@/mixins/ListMixin'

  export default {
    name: 'ExhibitionList',
    mixins: [
      ListMixin
    ],

    created() {
      this.init();
    },

    methods: {
      init () {
        this.initializing('exhibition', 'exhibition');
      },
      getDataFromServer() {
        this.getData();
      },
      imgField(img) {
        return 'background-image: url('+this.image(img)+');' +
          ' width: 20px; height: 20px; background-size: cover;' +
          ' background-position: center; margin-right: 8px';
      },
      showItem(index) {
        let show = true;
        if(this.checkServiceVersion(2)) show = true;
        else if(index<5) {
          show = false;
        }
        return show;
      },
      clickItem(item, kind) {
        if ( kind === 'update' ) {
          this.$router.push(this.getPath('exhibition/create?id='+item.id));
        }
        else if ( kind === 'delete' ) {
          let value = {
            id: item.id,
            url: 'exhibition/',
            title: '기획전을 삭제하시겠습니까?'
          }

          this.$store.commit('openModal', {type: 'modal-delete', value: value, width: 500});
        }
      },

      deleteItem(){
        this.$axios.delete(this.getUrl('exhibition') + this.modalItem)
          .then(res => {
            if (res.status === 200) {

            }
          });
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>

</style>
